// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"2":"369f2d1b31d83f79","334":"669a261380374549","608":"6445a3c75b18f3c9","634":"c3007b62c6b971f4","862":"76c9226e3d8145d9","920":"980185708404b0fa"}[chunkId] + ".js";
};